import { render, staticRenderFns } from "./walletIcon.vue?vue&type=template&id=3b853ea8&"
import script from "./walletIcon.vue?vue&type=script&lang=js&"
export * from "./walletIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports